import { useModel as _useModel, mergeModels as _mergeModels } from 'vue'
import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "char-limited-field" }
const _hoisted_2 = ["id", "name", "rows", "maxlength", "placeholder", "disabled"]
const _hoisted_3 = ["id", "name", "maxlength", "placeholder", "disabled"]

import { computed } from "vue";


export default {
  __name: 'CharacterLimitedField',
  props: /*@__PURE__*/_mergeModels({
	maxLength: { type: Number, required: true },
	multiline: { type: Boolean, default: false },
	rows: { type: Number, default: 2 },
	id: { type: String, default: undefined },
	name: { type: String, default: undefined },
	placeholder: { type: String, default: "" },
	disabled: { type: Boolean, default: false },
}, {
    "modelValue": { type: String, default: "" },
    "modelModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(["blur"], ["update:modelValue"]),
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const model = _useModel(__props, "modelValue");

const counterClass = computed(() =>
	props.multiline
		? "char-limited-field__counter--block"
		: "char-limited-field__counter--inline",
);

const charsLeftLabel = computed(() => {
	const remaining = Math.max(0, props.maxLength - (model.value?.length ?? 0));

	return `Noch ${remaining} Zeichen`;
});

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.multiline)
      ? _withDirectives((_openBlock(), _createElementBlock("textarea", {
          key: 0,
          id: __props.id,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((model).value = $event)),
          name: __props.name,
          class: "form-control char-limited-field__control char-limited-field__control--block",
          rows: __props.rows,
          maxlength: __props.maxLength,
          placeholder: __props.placeholder,
          disabled: __props.disabled,
          onBlur: _cache[1] || (_cache[1] = $event => (emit('blur')))
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_2)), [
          [_vModelText, model.value]
        ])
      : _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 1,
          id: __props.id,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((model).value = $event)),
          name: __props.name,
          type: "text",
          class: "form-control char-limited-field__control char-limited-field__control--inline",
          maxlength: __props.maxLength,
          placeholder: __props.placeholder,
          disabled: __props.disabled,
          onBlur: _cache[3] || (_cache[3] = $event => (emit('blur')))
        }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_3)), [
          [_vModelText, model.value]
        ]),
    _createElementVNode("small", {
      class: _normalizeClass(["char-limited-field__counter", counterClass.value])
    }, _toDisplayString(charsLeftLabel.value), 3 /* TEXT, CLASS */)
  ]))
}
}

}